import { consolidatedServerMap } from './serverMaps';

interface ServerMergeHistory {
  originalServer: string;
  mergeDate: string;
}

export interface Server {
  name: string;
  type: 'Live' | 'Progression';
  status: 'Active' | 'Merged';
  mergedInto?: string;
  mergeHistory?: ServerMergeHistory[];
}

// Re-export consolidatedServerMap with its type
export { consolidatedServerMap };
export type { ServerMergeHistory };

// Current live servers
const liveServers: Server[] = [
  { name: 'Antonius Bayle', type: 'Live', status: 'Merged', mergedInto: 'Bristlebane', mergeHistory: [
    { originalServer: 'Kane Bayle', mergeDate: '22-Mar-05' },
    { originalServer: 'Kael Drakkel', mergeDate: '30-Jun-05' },
    { originalServer: 'Sebilis', mergeDate: '30-Jun-05' },
    { originalServer: 'Vegnil Sathir', mergeDate: '30-Jun-05' }
  ]},
  { name: 'Bertoxxulous', type: 'Live', status: 'Merged', mergedInto: 'Xegony', mergeHistory: [
    { originalServer: 'Saryrn', mergeDate: '22-Jun-10' },
    { originalServer: 'Tholuxe Paells', mergeDate: '28-Apr-05' }
  ]},
  { name: 'Bristlebane', type: 'Live', status: 'Merged', mergedInto: 'Tunare', mergeHistory: [
    { originalServer: 'Solusek Ro', mergeDate: '23-Mar-05' },
    { originalServer: 'The Tribunal', mergeDate: '22-Jun-10' }
  ]},
  { name: 'Cazic-Thule', type: 'Live', status: 'Merged', mergedInto: 'Drinal', mergeHistory: [
    { originalServer: 'Brell Serilis', mergeDate: '7-Apr-05' },
    { originalServer: 'Fennin Ro', mergeDate: '22-Jun-10' }
  ]},
  { name: 'Drinal', type: 'Live', status: 'Merged', mergedInto: 'Tunare', mergeHistory: [
    { originalServer: 'Maelin Starpyre', mergeDate: '22-Jun-10' },
    { originalServer: 'Tarew Marr', mergeDate: '14-Apr-05' }
  ]},
  { name: 'Druzzil Ro', type: 'Live', status: 'Merged', mergedInto: 'Xegony', mergeHistory: [
    { originalServer: 'The Combine', mergeDate: '4-Mar-09' },
    { originalServer: 'Xev', mergeDate: '19-May-05' }
  ]},
  { name: 'Erollisi Marr', type: 'Live', status: 'Merged', mergedInto: 'Tunare', mergeHistory: [
    { originalServer: 'Morell Thule', mergeDate: '16-May-05' },
    { originalServer: 'The Nameless', mergeDate: '22-Jun-10' }
  ]},
  { name: 'Fennin Ro', type: 'Live', status: 'Merged', mergedInto: 'Cazic-Thule', mergeHistory: [
    { originalServer: 'Torvonnilous', mergeDate: '23-May-05' }
  ]},
  { name: 'Firiona Vie', type: 'Live', status: 'Merged', mergedInto: 'Tunare', mergeHistory: [
    { originalServer: 'Brekt', mergeDate: '20-Apr-20' }
  ]},
  { name: 'Luclin', type: 'Live', status: 'Merged', mergedInto: 'Xegony', mergeHistory: [
    { originalServer: 'Veeshan', mergeDate: '25-Apr-05' },
    { originalServer: 'Stromm', mergeDate: '22-Jun-10' }
  ]},
  { name: 'Maelin Starpyre', type: 'Live', status: 'Merged', mergedInto: 'Drinal', mergeHistory: [
    { originalServer: 'Vazaelle', mergeDate: '9-May-05' }
  ]},
  { name: 'Povar', type: 'Live', status: 'Merged', mergedInto: 'Tunare', mergeHistory: [
    { originalServer: 'Morden Rasp', mergeDate: '11-Apr-05' },
    { originalServer: 'Terris Thule', mergeDate: '26-May-05' },
    { originalServer: 'Quellious', mergeDate: '22-Jun-10' }
  ]},
  { name: 'Quellious', type: 'Live', status: 'Merged', mergedInto: 'Povar', mergeHistory: [
    { originalServer: 'Rodcet Nife', mergeDate: '12-May-05' }
  ]},
  { name: 'Ragefire', type: 'Live', status: 'Merged', mergedInto: 'Tunare', mergeHistory: [
    { originalServer: 'Lockjaw', mergeDate: '20-Apr-20' }
  ]},
  { name: 'Saryrn', type: 'Live', status: 'Merged', mergedInto: 'Bertoxxulous', mergeHistory: [
    { originalServer: 'Mithaniel Marr', mergeDate: '18-Apr-05' }
  ]},
  { name: 'The Combine', type: 'Live', status: 'Merged', mergedInto: 'Druzzil Ro', mergeHistory: [
    { originalServer: 'The Sleeper', mergeDate: '21-Mar-07' }
  ]},
  { name: 'The Nameless', type: 'Live', status: 'Merged', mergedInto: 'Erollisi Marr', mergeHistory: [
    { originalServer: 'Innoruuk', mergeDate: '2-May-05' }
  ]},
  { name: 'The Rathe', type: 'Live', status: 'Merged', mergedInto: 'Tunare', mergeHistory: [
    { originalServer: 'Karana', mergeDate: '18-Apr-05' },
    { originalServer: 'Prexus', mergeDate: '22-Jun-10' }
  ]},
  { name: 'The Seventh Hammer', type: 'Live', status: 'Merged', mergedInto: 'Tunare', mergeHistory: [
    { originalServer: 'Lanys T\'Vyl', mergeDate: '11-Apr-05' }
  ]},
  { name: 'The Tribunal', type: 'Live', status: 'Merged', mergedInto: 'Bristlebane', mergeHistory: [
    { originalServer: 'Ayonae Ro', mergeDate: '21-Apr-05' }
  ]},
  { name: 'Tunare', type: 'Live', status: 'Active', mergeHistory: [
    { originalServer: 'E\'ci', mergeDate: '31-May-05' },
    { originalServer: 'Mayong', mergeDate: '9-Sep-10' },
    { originalServer: 'The Seventh Hammer', mergeDate: '22-Jun-10' }
  ]},
  { name: 'Vox', type: 'Live', status: 'Active', mergeHistory: [
    { originalServer: 'Fippy Darkpaw', mergeDate: '20-Apr-20' },
    { originalServer: 'Phingel', mergeDate: '20-Jul-22' },
    { originalServer: 'Miragul', mergeDate: '20-Jul-22' },
    { originalServer: 'Trakanon', mergeDate: '20-Apr-20' }
  ]},
  { name: 'Xegony', type: 'Live', status: 'Active', mergeHistory: [
    { originalServer: 'Druzzil Ro', mergeDate: '22-Jun-10' },
    { originalServer: 'Zebuxoruk', mergeDate: '5-May-05' }
  ]},
  { name: 'Zek', type: 'Live', status: 'Merged', mergedInto: 'Tunare', mergeHistory: [
    { originalServer: 'Rallos Zek', mergeDate: '8-Feb-05' },
    { originalServer: 'Tallon Zek', mergeDate: '8-Feb-05' },
    { originalServer: 'Sullon Zek', mergeDate: '8-Feb-05' },
    { originalServer: 'Vallon Zek', mergeDate: '8-Feb-05' }
  ]}
];

// Current progression servers
const progressionServers: Server[] = [
  { name: 'Agnarr', type: 'Progression', status: 'Active' },
  { name: 'Aradune', type: 'Progression', status: 'Active' },
  { name: 'Coirnav', type: 'Progression', status: 'Active' },
  { name: 'Mangler', type: 'Progression', status: 'Active' },
  { name: 'Mischief', type: 'Progression', status: 'Active' },
  { name: 'Ragefire', type: 'Progression', status: 'Active' },
  { name: 'Rizlona', type: 'Progression', status: 'Active' },
  { name: 'Thornblade', type: 'Progression', status: 'Active' },
  { name: 'Vaniki', type: 'Progression', status: 'Active' },
  { name: 'Yelinak', type: 'Progression', status: 'Active' }
];

// Helper function to get current server name
export function getCurrentServerName(originalServer: string): string {
  // If server is in active servers list, return as is
  if (liveServers.some(s => s.name === originalServer)) {
    return originalServer;
  }

  // Check if server is in mergeHistory
  const mergedServer = liveServers.find(server => 
    server.mergeHistory?.some(merge => merge.originalServer === originalServer)
  );

  if (mergedServer) {
    return mergedServer.name;
  }

  return originalServer;
}

// Helper function to get merge history for a server
export function getServerMergeHistory(serverName: string): ServerMergeHistory[] | undefined {
  const server = liveServers.find(s => s.name === serverName);
  return server?.mergeHistory;
}

// Helper function to get the final server name from consolidatedServerMap
export function getFinalServerName(serverName: string): string {
  // First check if it's a final server (a key in consolidatedServerMap)
  if (Object.keys(consolidatedServerMap).includes(serverName)) {
    return serverName;
  }

  // Then check if it's in any server's merged list
  for (const [finalServer, mergedServers] of Object.entries(consolidatedServerMap)) {
    if (mergedServers.includes(serverName)) {
      return finalServer;
    }
  }

  // If not found in consolidatedServerMap, return original name
  // This handles progression servers and any servers not in the merge history
  return serverName;
}

// Export all servers for dropdown
export const allServers = [...liveServers, ...progressionServers]
  .sort((a, b) => a.name.localeCompare(b.name));

// Export all server names (including historic) for validation
export const allServerNames = Array.from(new Set([
  ...allServers.map(s => s.name),
  ...allServers.flatMap(s => s.mergeHistory?.map(m => m.originalServer) || []),
  ...Object.keys(consolidatedServerMap),
  ...Object.values(consolidatedServerMap).flat(),
  ...progressionServers.map(s => s.name)
])).sort(); 